import { getSessionUUID, getOrCreateDeviceId } from '../components/lib/AuthToken'; // Import the utility function
import logger from "../utils/logger";


export const fetch_all_profiles = async () => {
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
        };

        // Send Request to backend
        const response = await fetch('/profile/get_all_profiles', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error fetching profiles:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const suspend_profile = async (profile_id, new_status) => {
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ 'profile_id': profile_id, 'new_status': new_status })
        };

        // Send Request to backend
        const response = await fetch('/profile/suspend_profile', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error updating profile:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const update_profile = async (profile_data) => {
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ profile_data })
        };

        // Send Request to backend
        const response = await fetch('/profile/update_profile', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error updating profile:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const reset_totp = async (uuid) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/dev/reset_totp', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify({ uuid }),
        });
        const responseBody = await response.json();
        return { message: responseBody.message || responseBody.error, status: response.status };
    } catch (err) {
        logger.error('Error resetting TOTP:', err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

//-------------------------------------------------------------------------------------------------

export const reset_password = async (data) => {
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ email: data.email, uuid: data.uuid })
        };

        // Send Request to backend
        const response = await fetch('/profile/reset_password', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: responseBody.message,
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error updating profile:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const changePassword = async (body) => {
    const sessionToken = await getSessionUUID();
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionToken}`,
        },
        body: JSON.stringify(body),
    };

    const response = await fetch('/auth/changepassword', requestOptions);
    const responseBody = await response.json();
    return { status: response.status, responseBody };
};

//-------------------------------------------------------------------------------------------------
export const validatePassword = async (password, email) => {
    const sessionToken = await getSessionUUID();
    const body = { password: password, email: email };
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionToken}`,
        },
        body: JSON.stringify(body),
    };

    const response = await fetch('/auth/verify-password', requestOptions);
    const responseBody = await response.json();
    return { status: response.status, responseBody };
};

//-------------------------------------------------------------------------------------------------

export const use_update_token = async (token, profile_id) => {
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        const device_id = getOrCreateDeviceId();

        const profile_data = {
            profile_id: profile_id,
            token: token,
            device_id: device_id,
            device_type: 'web',
            platform: 'web',
        };

        logger.log("Profile Data:", profile_data);

        // Options to send data to backend
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ profile_data })
        };

        // Send Request to backend
        const response = await fetch('/profile/update_token', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error updating profile:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};
